import { remoteUrl, urlWithParams } from "../../helpers/UrlHelpers";

const CRAFTY_CRAFT_URL  = process.env.REACT_APP_MINECRAFT_URL;

function categoryPath(this: any, target_id: number, id: number ) {
  let target;

  switch (target_id) {
    case 1:
      target = 'skins';
      break;
    case 2:
      target = 'worlds';
      break;
    case 3:
      target = 'addon_templates';
      break;
    case 5:
      target = 'main_skins';
      break;
    default:
      target = '';
  }

  return `/${this.basePath}/${target}?category_id=${id}`;
}

function usersPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/users`, params);
}
function userPath(this: any, id: number) {
  return `/${this.basePath}/users/${id}`;
}

function worldsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/worlds`, params);
}
function worldPath(this: any, id: number) {
  return `/${this.basePath}/worlds/${id}`;
}

function skinsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/skins`, params);
}
function skinPath(this: any, id: number) {
  return `/${this.basePath}/skins/${id}`;
}

function mainSkinsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/main_skins`, params);
}
function mainSkinPath(this: any, id: number) {
  return `/${this.basePath}/main_skins/${id}`;
}

function addonTemplatesPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/addon_templates`, params);
}
function addonTemplatePath(this: any, id: number) {
  return `/${this.basePath}/addon_templates/${id}`;
}

function addonPath(this: any, id: number) {
  return `/${this.basePath}/addons/${id}`;
}
function addonsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/addons`, params);
}
function addonsTrendingPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/addons/trending`, params);
}
function addonsPopularPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/addons/popular`, params);
}
function addonsRecentsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/addons/recents`, params);
}

function addonsUnpublishedPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/addons/unpublished`, params);
}

function serverPath(this: any, id: number) {
  return `/${this.basePath}/servers/${id}`;
}
function serversPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/servers`, params);
}
function serversUnpublishedPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/servers/unpublished`, params);
}

function serverPlansPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/server_plans`, params);
}

function hostingPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/hosting`, params);
}

function reportsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/reports`, params);
}
function reportAddonsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/reports/addons`, params);
}
function reportUsersPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/reports/users`, params);
}
function reportCommentsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/reports/comments`, params);
}

function bannersPath(this: any, params?: object) {
    return urlWithParams(`/${this.basePath}/banners`, params);
}

function framesPath(this: any, params?: object) {
    return urlWithParams(`/${this.basePath}/frames`, params);
}

function avatarsPath(this: any, params?: object) {
    return urlWithParams(`/${this.basePath}/avatars`, params);
}

function usernameStylesPath(this: any, params?: object) {
    return urlWithParams(`/${this.basePath}/username_styles`, params);
}

function commentPath(this: any, comment?: any) {
  const params = { tab: 'comment', go_to_comment: comment.id };
  let targetUrl;

  switch (comment.parent_target_type) {
    case 'Addon':
      targetUrl = addonPath.call(this, comment.parent_target_id);
      break;
    case 'Skin':
      targetUrl = skinPath.call(this, comment.parent_target_id);
      break;
    case 'World':
      targetUrl = worldPath.call(this, comment.parent_target_id);
      break;
    case 'AddonTemplate':
      targetUrl = addonTemplatePath.call(this, comment.parent_target_id);
      break;
    case 'MainSkin':
      targetUrl = mainSkinPath.call(this, comment.parent_target_id);
      break;
    case 'User':
      targetUrl = userPath.call(this, comment.parent_target_id);
      break;
    case 'Challenge':
      targetUrl = challengePath.call(this, comment.parent_target_id);
      break;
    case 'Server':
      targetUrl = serverPath.call(this, comment.parent_target_id);
      break;
    default:
      targetUrl = '/404';
  }

  return targetUrl ? urlWithParams(targetUrl, params) : null;
}

function youtubeVideosPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/youtube_videos`, params);
}

function tipsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/tips`, params);
}
function tipPath(this: any, id: number) {
  return `/${this.basePath}/tip_steps?tip_id=${id}`;
}

function bundlePath(this: any, id: number) {
  return `/${this.basePath}/bundles/${id}`;
}
function bundlesPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/bundles`, params);
}

function notificationPath(this: any, id: number) {
  return `/${this.basePath}/notifications/${id}`;
}
function notificationsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/notifications`, params);
}

function devicePath(this: any, id: number) {
  return `/${this.basePath}/devices/${id}`;
}
function devicesPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/devices`, params);
}

function challengePath(this: any, id: number) {
  return `/${this.basePath}/challenges/${id}`;
}
function challengesPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/challenges`, params);
}

function bannedIpsPath(this: any, params?: object) {
  return urlWithParams(`/${this.basePath}/banned_ips`, params);
}
function bannedIpPath(this: any, id: number) {
  return `/${this.basePath}/banned_ips/${id}`;
}

const minecraftUrls = {
  baseURL: CRAFTY_CRAFT_URL,
  get basePath() {
    return document.location.pathname.includes('mods_craft') ? 'mods_craft' : 'crafty_craft';
  },

  remoteUrl: remoteUrl,

  addonPath:              addonPath,
  addonsPath:             addonsPath,
  addonsTrendingPath:     addonsTrendingPath,
  addonsPopularPath:      addonsPopularPath,
  addonsRecentsPath:      addonsRecentsPath,
  addonsUnpublishedPath:  addonsUnpublishedPath,

  serverPath:             serverPath,
  serversPath:            serversPath,
  serversUnpublishedPath: serversUnpublishedPath,
  serverPlansPath:        serverPlansPath,
  hostingPath:            hostingPath,

  usersPath:          usersPath,

  skinsPath:          skinsPath,
  skinPath:           skinPath,

  worldsPath:         worldsPath,
  worldPath:          worldPath,

  addonTemplatePath:  addonTemplatePath,
  addonTemplatesPath: addonTemplatesPath,

  mainSkinPath:       mainSkinPath,
  mainSkinsPath:      mainSkinsPath,

  categoryPath:       categoryPath,
  userPath:           userPath,

  reportsPath:        reportsPath,
  reportAddonsPath:   reportAddonsPath,
  reportUsersPath:    reportUsersPath,
  reportCommentsPath: reportCommentsPath,

  commentPath:        commentPath,

  youtubeVideosPath:  youtubeVideosPath,

  tipsPath:           tipsPath,
  tipPath:            tipPath,

  bundlePath:         bundlePath,
  bundlesPath:        bundlesPath,

  notificationPath:   notificationPath,
  notificationsPath:  notificationsPath,

  devicePath:   devicePath,
  devicesPath:  devicesPath,

  challengePath:   challengePath,
  challengesPath:  challengesPath,

  bannersPath:    bannersPath,
  framesPath:     framesPath,
  avatarsPath:    avatarsPath,
  usernameStylesPath:  usernameStylesPath,

  bannedIpsPath:  bannedIpsPath,
  bannedIpPath:   bannedIpPath,
}

export default minecraftUrls;
